import React, { lazy, Suspense } from 'react';
import { Events } from '../utils/constants';
import UxCart from '@ux/cart';
import { withNamespace, NamespaceConsumer } from '@ux/namespace-component';

const HeaderCart = lazy(() => import(/* webpackChunkName: "header-cart" */ './HeaderCart'));

class HeaderCartLoader extends NamespaceConsumer {
  constructor(props) {
    super(props);
    this.enable = this.enable.bind(this);
    this.setProps = this.setProps.bind(this);

    this.state = {
      enable: false,
      checkout: props.checkout,
      checkRestrictedDomains: props.checkRestrictedDomains
    };
  }

  isHeaderCartEligible() {
    const isIE = typeof window !== 'undefined' && (/* @cc_on!@*/false || !!document.documentMode);
    return this.state.enable && !this.isMobile && !isIE;
  }

  componentDidMount() {
    document.addEventListener(Events.PROPS, this.setProps);
    document.addEventListener(Events.ENABLE, this.enable);
  }

  componentWillUnmount() {
    document.removeEventListener(Events.PROPS, this.setProps);
    document.removeEventListener(Events.ENABLE, this.enable);
  }

  enable() {
    this.setState({ enable: true });
  }

  setProps(event) {
    if (event && event.detail && event.detail.checkoutUrl) {
      this.setState({ checkout: event.detail.checkoutUrl });
    }
    if (event && event.detail && event.detail.checkRestrictedDomains) {
      this.setState({ checkRestrictedDomains: event.detail.checkRestrictedDomains });
    }
  }

  render() {
    return this.isHeaderCartEligible() ?
      <Suspense fallback={ <UxCart { ...this.props } checkout={ this.state.checkout }/>  }>
        <HeaderCart { ...this.props } checkout={ this.state.checkout } checkRestrictedDomains={ this.state.checkRestrictedDomains } />
      </Suspense> : <UxCart { ...this.props } checkout={ this.state.checkout }/>;
  }
}

export default withNamespace(HeaderCartLoader);
